<template>
  <div>
    <div
      class="sticky-below-header !top-[--layout-offset-top] z-10 bg-white py-2 shadow shadow-black/5"
    >
      <tag-page-navigation base-route-item />
    </div>

    <nuxt-page :page-key="$route.path" />
  </div>
</template>
